import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';

import { DeleteConfirmationDialogComponent } from './delete-confirmation-dialog.component';

@NgModule({
  declarations: [DeleteConfirmationDialogComponent],
  exports: [DeleteConfirmationDialogComponent],
  imports: [
    CommonModule,
    NzModalModule,
    NzButtonModule,
    NzIconModule,
  ]
})
export class DeleteConfirmationDialogModule { }
